// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldNote2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.5503 20.1619C13.2903 20.2719 13.0103 20.3719 12.7103 20.4719L11.1303 20.9919C7.16034 22.2719 5.07034 21.2019 3.78034 17.2319L2.50034 13.2819C1.22034 9.31187 2.28034 7.21187 6.25034 5.93187L7.79034 5.42188C7.60034 5.90187 7.44034 6.45188 7.29034 7.07188L6.31034 11.2619C5.21034 15.9719 6.82034 18.5719 11.5303 19.6919L13.2103 20.0919C13.3203 20.1219 13.4403 20.1419 13.5503 20.1619Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.1702 3.20854L15.5002 2.81854C12.1602 2.02854 10.1702 2.67854 9.00018 5.09854C8.70018 5.70854 8.46018 6.44854 8.26018 7.29854L7.28018 11.4885C6.30018 15.6685 7.59018 17.7285 11.7602 18.7185L13.4402 19.1185C14.0202 19.2585 14.5602 19.3485 15.0602 19.3885C18.1802 19.6885 19.8402 18.2285 20.6802 14.6185L21.6602 10.4385C22.6402 6.25854 21.3602 4.18854 17.1702 3.20854Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldNote2 };
